// actions/index.js

import { SET_MASTER, SET_POINTS, SET_QUESTION, TOGGLE_SOUND } from "./types";
export const SET_USER_UID = "SET_USER_UID";

/**
 * Action creator to toggle the sound setting in the app.
 * @returns {Object} Redux action with type TOGGLE_SOUND
 */
export const toggleSound = () => ({
  type: TOGGLE_SOUND,
});

/**
 * Action creator to set the current question index.
 * @param {number} question - The index of the current question.
 * @returns {Object} Redux action with type SET_QUESTION and payload
 */
export const setQuestion = (question) => ({
  type: SET_QUESTION,
  payload: question,
});

/**
 * Action creator to set the current sutra index (master index).
 * @param {number} value - The index of the current sutra.
 * @returns {Object} Redux action with type SET_MASTER and payload
 */
export const sutraMaster = (value) => ({
  type: SET_MASTER,
  payload: value,
});

/**
 * Action creator to set the current sutra points.
 * @param {number} value - The current points for the sutra.
 * @returns {Object} Redux action with type SET_POINTS and payload
 */
export const sutraPoints = (value) => ({
  type: SET_POINTS,
  payload: value,
});

/**
 * Action creator to set the authenticated user's UID in the Redux store.
 * This should be dispatched after a successful login or when the app
 * detects an authenticated user on initialization.
 *
 * @param {string} uid - The unique identifier of the authenticated user from Firebase Auth.
 * @returns {Object} Redux action with type SET_USER_UID and the UID as payload
 */
export const setUserUid = (uid) => ({
  type: SET_USER_UID,
  payload: uid,
});
